<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5 rounded p-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.utmtco.com\/storage\/assets\/kLLPswEEvUAqlaag5pDfINSu9CHgQXUL9n50Ajnq.webp1746427701.webp","alt":"utmtco"},...{}}' :style='""' class="col-6 mx-auto mb-5" ></m-img><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>تعاون   </template>
                </m-h3><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>
تعتبر شركة یوتاب مهر تندیس التجارية الأكثر شهرة اليوم أنها تنشئ مجموعة متنوعة من المنتجات عبر دول العالم من آسيا وأوروبا وأفريقيا وأمريكا وجميع البلدان إلى جميع أنحاء العالم، مما يؤدي إلى انتشارها وازدهارها بازاریابی اعطاء نماید .
جميع الشركات العزيزة التي خططت للتعاون معنا ساهمت في استكمال نموذج العمل المبتكر أو باستخدامنا عبر الواتساب عبر الإنترنت بشكل كامل لتفاعل الابتكار.   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"border-bottom:2px solid black;\nfont-size: 20px;"' class="mb-5 text-primary d-inline-block pb-3" >
                <template #default>لتلقي النصائح والتواصل، يرجى ملء النموذج أدناه.   </template>
                </m-h2></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="justify-content-center row mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-4","formId":2,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center my-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='"font-size: 16px;"' class="mb-4" >
                <template #default>عنوان: إيران . محافظة خوزستان، مدينة دزفول، شارع الدكتور شريعتي   </template>
                </m-h3><m-a v-bind='{...{"href":"","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>adel.tandis@gmail.com   </template>
                </m-a><m-a v-bind='{...{"href":"","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>info @utmtco.com   </template>
                </m-a><m-div v-bind='{...{},...{}}' :style='""' class="font-weight-bolder mt-3" >
                <template #default>   <m-a v-bind='{...{"href":"tel:+986142544241","target":"_self"},...{}}' :style='" direction: ltr;\nfont-family:arial"' class="d-block text-dark my-2" >
                <template #default>+986142544241   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+989190102898","target":"_self"},...{}}' :style='" direction: ltr;\nfont-family:arial"' class="d-block text-dark my-2" >
                <template #default>+989190102898   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+989166469640","target":"_self"},...{}}' :style='" direction: ltr;\nfont-family:arial"' class="d-block text-dark my-2" >
                <template #default>+989166469640   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mH3,mP,mH2,mFormSingle1,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
